export interface FeedPost {
  id: string;
  type: 'video' | 'image' | 'article';
  emoji: string;
  content: string;
  account: string;
  tags: string[];
}

export interface InferredTrait {
  label: string;
  icon: string;
  triggeredBy: string[]; // post ids
  adCategory: string;
}

export const FEED_POSTS: FeedPost[] = [
  { id: 'p1',  type: 'video',   emoji: '🎮', content: 'Top 10 open-world games dropping this year — you won\'t believe #3', account: '@GamersWorld', tags: ['gaming', 'entertainment'] },
  { id: 'p2',  type: 'image',   emoji: '🐕', content: 'This golden retriever learned to open the fridge 😂', account: '@DailyPaws', tags: ['animals', 'cute', 'humor'] },
  { id: 'p3',  type: 'article', emoji: '🎵', content: 'Why this underground artist is about to blow up (here\'s the data)', account: '@MusicInsider', tags: ['music', 'trending'] },
  { id: 'p4',  type: 'video',   emoji: '⚽', content: 'The goal that broke the internet — slow-mo breakdown', account: '@SportsMoments', tags: ['sports', 'soccer'] },
  { id: 'p5',  type: 'image',   emoji: '🍕', content: 'Rating every pizza chain from worst to best (scientific method)', account: '@FoodRankings', tags: ['food', 'humor'] },
  { id: 'p6',  type: 'article', emoji: '💡', content: 'This teen built an AI in their bedroom — here\'s how', account: '@TechStories', tags: ['tech', 'inspiration'] },
  { id: 'p7',  type: 'video',   emoji: '🎯', content: 'Minecraft build that took 847 hours — full timelapse', account: '@GamersWorld', tags: ['gaming', 'creativity'] },
  { id: 'p8',  type: 'image',   emoji: '🌏', content: 'Climate scientists found something unexpected in Arctic ice', account: '@ScienceNow', tags: ['science', 'climate'] },
  { id: 'p9',  type: 'video',   emoji: '🏀', content: 'Street basketball player vs. NBA rookie — who wins?', account: '@SportsMoments', tags: ['sports', 'basketball'] },
  { id: 'p10', type: 'article', emoji: '🧠', content: 'Why your brain craves short videos — the dopamine loop explained', account: '@MindLab', tags: ['science', 'psychology'] },
  { id: 'p11', type: 'image',   emoji: '🐱', content: 'My cat figured out how to use the smart speaker. Send help.', account: '@DailyPaws', tags: ['animals', 'cute', 'humor'] },
  { id: 'p12', type: 'video',   emoji: '🎸', content: 'Playing 5 songs simultaneously — one guitar, two hands', account: '@MusicInsider', tags: ['music', 'talent'] },
  { id: 'p13', type: 'article', emoji: '🔐', content: 'Your phone knows where you\'ve been for the last 3 years', account: '@TechStories', tags: ['tech', 'privacy'] },
  { id: 'p14', type: 'image',   emoji: '🍣', content: 'Ranked: every sushi type by how sus the Instagram photo looks', account: '@FoodRankings', tags: ['food', 'humor'] },
  { id: 'p15', type: 'video',   emoji: '🏋️', content: 'Day 1 vs Day 365 — unbelievable transformation', account: '@FitLife', tags: ['fitness', 'inspiration'] },
];

export const INFERRED_TRAITS: InferredTrait[] = [
  {
    label: 'Gamer',
    icon: '🎮',
    triggeredBy: ['p1', 'p7'],
    adCategory: 'Gaming hardware, in-app purchases, streaming subscriptions',
  },
  {
    label: 'Animal lover',
    icon: '🐾',
    triggeredBy: ['p2', 'p11'],
    adCategory: 'Pet food, vet services, cute merchandise',
  },
  {
    label: 'Music fan',
    icon: '🎵',
    triggeredBy: ['p3', 'p12'],
    adCategory: 'Concert tickets, streaming, headphones, merch',
  },
  {
    label: 'Sports fan',
    icon: '⚽',
    triggeredBy: ['p4', 'p9'],
    adCategory: 'Sports gear, betting platforms, energy drinks',
  },
  {
    label: 'Foodie',
    icon: '🍕',
    triggeredBy: ['p5', 'p14'],
    adCategory: 'Food delivery, restaurant deals, cooking subscriptions',
  },
  {
    label: 'Tech-curious',
    icon: '💻',
    triggeredBy: ['p6', 'p13'],
    adCategory: 'Coding courses, gadgets, productivity apps',
  },
  {
    label: 'Science-minded',
    icon: '🔬',
    triggeredBy: ['p8', 'p10'],
    adCategory: 'Educational apps, documentaries, STEM products',
  },
  {
    label: 'Fitness-motivated',
    icon: '💪',
    triggeredBy: ['p15'],
    adCategory: 'Gym memberships, supplements, sportswear',
  },
];

export const DARK_PATTERNS = [
  { id: 'dp1', name: 'Pre-ticked consent box', description: 'Marketing emails opt-in is already checked. You have to un-tick it.', difficulty: 1 },
  { id: 'dp2', name: 'Confirmshaming', description: '"No thanks, I don\'t want to save money" — making the reject option feel shameful.', difficulty: 1 },
  { id: 'dp3', name: 'Roach Motel', description: 'Easy to subscribe in 1 click. Cancel requires calling a phone number during business hours.', difficulty: 2 },
  { id: 'dp4', name: 'Hidden unsubscribe', description: 'Unsubscribe link is in 6pt grey text, matching the background colour.', difficulty: 2 },
  { id: 'dp5', name: 'Cookie wall', description: '"Accept all or pay €4.99/month." Consent isn\'t really consent if the alternative costs money.', difficulty: 3 },
  { id: 'dp6', name: 'Data sharing buried in settings', description: 'Sharing your data with 200 companies requires navigating 8 settings menus.', difficulty: 3 },
];
